import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { BehaviorSubject } from "rxjs";

class BinanceFuturesLtpWebsocket {
  messageSource = new BehaviorSubject(" ");
  currentMessage = this.messageSource.asObservable();

  reqNo = null;
  buyingasset = null;
  webSocketAPI = null;
  obj = null;
  sellingasset = null;
  ticker = null;
  depth = null;
  trade = null;
  webSocketEndPoint =
    "https://copytrading-socket.paybito.com:8443/futures-websocket/fwebsocket";
  topic = "/topic/name";
  stompClient = null;
  chartComponent = null;
  assetPair = null;

  constructor() {}

  _connect = () => {
    console.log("binance CONNECT");

    if (localStorage.getItem("access_token")) {
      const ws = new SockJS(this.webSocketEndPoint);
      this.stompClient = Stomp.over(ws);

      this.stompClient.connect(
        {},
        (frame) => {
          this.stompClient.subscribe(this.topic, (sdkEvent) => {
            this.onMessageReceived(sdkEvent);
          });
        },
        this.errorCallBack
      );

      this.stompClient.debug = null;
    } else {
      window.location.href = "https://trade.paybito.com/";
    }
  };

  _disconnect = () => {
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
  };

  errorCallBack = (error) => {
    console.log("errorCallBack -> ", error);
    setTimeout(() => {
      this._connect();
    }, 5000);
  };

  _send = (message) => {
    this.stompClient.send("/app/sendRequest", {}, JSON.stringify(message));
  };

  onMessageReceived = (message) => {
    const obj = JSON.parse(message.body);
    this.changeMessage(obj);
  };

  changeMessage = (obj) => {
    this.messageSource.next(obj);
  };

  subscribe = () => {
    // Placeholder if subscription logic is re-added
  };

  unsubscribe = () => {
    try {
      const pair = localStorage.getItem("selected_derivative_asset_pair");
      if (pair) {
        this.assetPair = pair.toLowerCase();
        this.ticker = "@ticker";
        this.depth = "@depth";
        this.trade = "@trade";
        const req = {
          method: "UNSUBSCRIBE",
          params: [
            this.assetPair + this.ticker,
            this.assetPair + this.depth,
            this.assetPair + this.trade,
          ],
          id: this.reqNo,
        };
        this._send(req);
      }
    } catch (e) {
      //   location.reload();
    }
  };
}

export default BinanceFuturesLtpWebsocket;
